import SDIcon from './SDIcon'

const IconCarbonMisuseOutline = (props) => (
  <SDIcon title='Warning alt' {...props}>
    <path
    d='M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12
    S22.6,28,16,28z'
    />
    <polygon points='21.4,23 16,17.6 10.6,23 9,21.4 14.4,16 9,10.6 10.6,9 16,14.4 21.4,9 23,10.6 17.6,16 23,21.4 ' />
  </SDIcon>
)

export default IconCarbonMisuseOutline
